import React, {FC} from 'react';
import './content.scss';

interface Props {
    headerText: string;
}

export const ContentHeader: FC<Props> = ({headerText}) => {

    return (
        <div className='content content-header'>
            {headerText}
        </div>
    )
}